"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const safeAreStyles = {
  paddingTop: _reactNative.Platform.OS === "android" ? _reactNative.StatusBar.currentHeight : 0
};
const webStyles = _reactNative.Platform.OS === "web" ? {
  container: {
    maxWidth: 768,
    margin: "auto",
    width: "100%"
  }
} : {};

function Header(props) {
  let {
    actionRenderer,
    logoRenderer,
    bottomRenderer,
    secondaryActionRenderer
  } = props;
  let stackDistribution = actionRenderer || secondaryActionRenderer ? "space-between" : "center";
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    bg: "primary.main"
  }, /*#__PURE__*/_react.default.createElement(_reactNative.SafeAreaView, {
    style: {
      paddingBottom: 0,
      ...safeAreStyles,
      ...webStyles.container
    }
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: stackDistribution,
    alignment: "center",
    p: "l"
  }, actionRenderer || /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      width: 36
    }
  }), logoRenderer, secondaryActionRenderer || /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      width: 36
    }
  })), bottomRenderer));
}

var _default = Header;
exports.default = _default;